import { gql } from '@apollo/client';

export * from './repoUploadVerificationFinished.subscription.generated';

export const REPO_UPLOAD_VERIFICATION_FINISHED = gql`
  subscription RepoUploadVerificationFinished($assetId: ID!) {
    repoUploadVerificationFinished(assetId: $assetId) {
      asset {
        id
        syncStatus
        depositStatus
        size
        error
        updatedAt
      }
      success
      error
    }
  }
`;
